/*
 * Copyright © 2021 Firecrest Clinical, Ltd.
 * All rights reserved.
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FcStudyNewsPreviewComponent } from './fc-study-news-preview.component';


/**
 * Fc study news preview module is used in study-news-ui and study-news-admin-ui.
 */
@NgModule({
    declarations: [
        FcStudyNewsPreviewComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        FcStudyNewsPreviewComponent
    ]
})
export class FcStudyNewsPreviewModule {
}
